module.exports = __webpack_public_path__ + "img/whatsapp.12745c42.png";